var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label ? _c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(),
    _c("div", { staticClass: "input-container" }, [
      _c("input", {
        style: { backgroundSize: _vm.backgroundSize },
        attrs: {
          type: "range",
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.form },
        on: { input: ({ target }) => (_vm.form = parseFloat(target.value)) },
      }),
      _c("div", { staticClass: "input-slider__value" }, [
        _c("input", {
          attrs: {
            type: "number",
            min: _vm.min,
            max: _vm.max,
            step: _vm.step,
            disabled: _vm.disabled,
          },
          domProps: { value: _vm.form },
          on: { input: ({ target }) => (_vm.form = parseFloat(target.value)) },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }